#import '../fragments/subscription-fragment.graphql'
#import '../fragments/coupon-fragment.graphql'

fragment AccountPlanFragment on AccountPlan {
    totalMonth
    totalMonthDisplay
    subtotalMonthDisplay
    accountDiscountDisplay
    accountCoupons {
        ...CouponFragment
    }
    nextEstimatedInvoice {
        id
        amount
        date
    }
    isCancelled
    crm {
        ...SubscriptionFragment
    }
    marketing {
        ...SubscriptionFragment
    }
    revenueBooster {
        ...SubscriptionFragment
    }
    nutshellIq {
        ...SubscriptionFragment
    }
    inbox {
        ...SubscriptionFragment
    }
    marketingSuite {
        ...SubscriptionFragment
    }
    smsCampaigns {
        ...SubscriptionFragment
    }
    quotes {
        ...SubscriptionFragment
    }
    nutshellAdvisor {
        ...SubscriptionFragment
    }
}
